import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.174 7.2a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667m-.473 4.607a.67.67 0 0 0 .947 0l2.726-2.734a4.527 4.527 0 1 0-6.4 0zM4.994 5.56a3.2 3.2 0 0 1 1.42-2.367 3.21 3.21 0 0 1 3.52 0 3.214 3.214 0 0 1 .5 4.94l-2.26 2.26-2.26-2.26a3.18 3.18 0 0 1-.92-2.573m7.847 7.773H3.508a.666.666 0 1 0 0 1.334h9.333a.667.667 0 1 0 0-1.334"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })